<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Dashboard do App</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Dashboard</div>
        </div>
        <button class="appui-btn appui-btn--ghost" @click="reload()"><i class="mdi mdi-refresh mr-1"></i> Atualizar</button>
      </div>

      <!-- Cards principais -->
      <div class="appui-dash-cards">
        <div v-for="c in mainCards" :key="c.key" class="appui-dash-card">
          <span class="appui-dash-icon" :style="{ background: c.bg, color: c.color }"><i :class="c.icon"></i></span>
          <div>
            <div class="appui-dash-value">{{ summary[c.key] != null ? summary[c.key] : '—' }}</div>
            <div class="appui-dash-label">{{ c.label }}</div>
          </div>
        </div>
      </div>

      <div class="appui-dash-grid">
        <!-- Engajamento por dia -->
        <section class="appui-card appui-card--flush">
          <div class="appui-card-toolbar">
            <div class="appui-card-toolbar-left"><span class="appui-sec-title">Engajamento — últimos 14 dias</span></div>
          </div>
          <div style="padding:6px 10px 10px">
            <apexchart v-if="chartReady" type="area" height="290" :options="chartOptions" :series="chartSeries"></apexchart>
            <div v-else class="appui-inline-empty">Carregando engajamento...</div>
          </div>
        </section>

        <div style="display:flex;flex-direction:column;gap:20px">
          <!-- Top ranking -->
          <section class="appui-card appui-card--flush">
            <div class="appui-card-toolbar">
              <div class="appui-card-toolbar-left"><span class="appui-sec-title">Top gamificação</span></div>
              <div class="appui-card-toolbar-right"><router-link to="/app/gamification" style="font-size:12px">ver ranking</router-link></div>
            </div>
            <div v-if="!topRanking.length" class="appui-inline-empty">Sem pontuação ainda.</div>
            <div v-else>
              <div v-for="(r, i) in topRanking" :key="r.id" style="display:flex;align-items:center;gap:10px;padding:9px 16px;border-top:1px solid #f4f5f8">
                <span style="width:24px;text-align:center;font-size:14px">{{ ['🥇', '🥈', '🥉'][i] || (i + 1) + 'º' }}</span>
                <span style="flex:1;font-weight:500;font-size:12.5px;color:#495057;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{ r.name }}</span>
                <span style="font-weight:700;color:#556ee6;font-size:12.5px">{{ r.total }} pts</span>
              </div>
            </div>
          </section>

          <!-- Últimos pedidos -->
          <section class="appui-card appui-card--flush">
            <div class="appui-card-toolbar">
              <div class="appui-card-toolbar-left"><span class="appui-sec-title">Últimos pedidos</span></div>
              <div class="appui-card-toolbar-right"><router-link to="/app/store" style="font-size:12px">ver loja</router-link></div>
            </div>
            <div v-if="!latestOrders.length" class="appui-inline-empty">Nenhum pedido ainda.</div>
            <div v-else>
              <div v-for="o in latestOrders" :key="o.id" style="display:flex;align-items:center;gap:10px;padding:9px 16px;border-top:1px solid #f4f5f8">
                <span style="flex:1;font-weight:500;font-size:12.5px;color:#495057;min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">#{{ o.id }} · {{ o.name || '—' }}</span>
                <span class="appui-badge" :class="o.status === 2 ? 'appui-badge--green' : (o.status === 1 ? 'appui-badge--blue' : '')">{{ orderLabels[o.status] || o.status }}</span>
                <span style="font-weight:700;color:#556ee6;font-size:12.5px">{{ o.total }} pts</span>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- Métricas secundárias -->
      <section class="appui-card appui-card--flush" style="margin-top:20px">
        <div class="appui-card-toolbar">
          <div class="appui-card-toolbar-left"><span class="appui-sec-title">Todas as métricas</span></div>
          <div class="appui-card-toolbar-right"><router-link to="/app/reports" style="font-size:12px">relatórios e exports</router-link></div>
        </div>
        <div class="appui-stat-grid">
          <div v-for="m in secondaryCards" :key="m.key" class="appui-stat">
            <span class="appui-stat-icon"><i :class="m.icon"></i></span>
            <div>
              <div class="appui-stat-value">{{ summary[m.key] != null ? summary[m.key] : '—' }}</div>
              <div class="appui-stat-label">{{ m.label }}</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { errorMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: { apexchart: VueApexCharts },
  name: 'app-dashboard',
  data () {
    return {
      summary: {},
      series: [],
      topRanking: [],
      latestOrders: [],
      chartReady: false,
      orderLabels: ['Processando', 'Enviado', 'Entregue'],
      mainCards: [
        { key: 'participants', label: 'Participantes confirmados', icon: 'bx bx-user', bg: '#eef1fb', color: '#556ee6' },
        { key: 'feed_posts', label: 'Posts no feed', icon: 'bx bx-news', bg: '#e7f7f0', color: '#34c38f' },
        { key: 'gamification_points', label: 'Pontos distribuídos', icon: 'bx bx-medal', bg: '#fdf6e7', color: '#f1b44c' },
        { key: 'room_askings', label: 'Perguntas nas salas', icon: 'bx bx-help-circle', bg: '#e9f4fd', color: '#50a5f1' },
        { key: 'store_orders', label: 'Pedidos na loja', icon: 'bx bx-package', bg: '#fdecec', color: '#f46a6a' },
        { key: 'certificates', label: 'Certificados emitidos', icon: 'bx bx-certification', bg: '#f0ecfb', color: '#6f42c1' }
      ],
      secondaryCards: [
        { key: 'feed_comments', label: 'Comentários', icon: 'bx bx-comment' },
        { key: 'feed_likes', label: 'Curtidas', icon: 'bx bx-heart' },
        { key: 'poll_votes', label: 'Votos em enquetes', icon: 'bx bx-bar-chart-square' },
        { key: 'quiz_answers', label: 'Respostas de quiz', icon: 'bx bx-check-square' },
        { key: 'word_cloud', label: 'Palavras (nuvem)', icon: 'bx bx-cloud' },
        { key: 'emojis', label: 'Reações', icon: 'bx bx-happy' },
        { key: 'survey_replies', label: 'Respostas da pesquisa', icon: 'bx bx-list-check' },
        { key: 'connections', label: 'Conexões', icon: 'bx bx-network-chart' },
        { key: 'indications', label: 'Indicações', icon: 'bx bx-user-plus' }
      ]
    }
  },
  computed: {
    chartSeries () {
      return [
        { name: 'Posts', data: this.series.map(s => s.posts) },
        { name: 'Comentários', data: this.series.map(s => s.comments) },
        { name: 'Curtidas', data: this.series.map(s => s.likes) },
        { name: 'Interações nas salas', data: this.series.map(s => s.rooms) }
      ]
    },
    chartOptions () {
      return {
        chart: { toolbar: { show: false }, fontFamily: 'Poppins, sans-serif' },
        colors: ['#556ee6', '#34c38f', '#f46a6a', '#f1b44c'],
        dataLabels: { enabled: false },
        stroke: { curve: 'smooth', width: 2.5 },
        fill: { type: 'gradient', gradient: { opacityFrom: 0.25, opacityTo: 0.02 } },
        legend: { position: 'top', horizontalAlign: 'right', fontSize: '12px' },
        grid: { borderColor: '#eff2f7', strokeDashArray: 3 },
        xaxis: {
          categories: this.series.map(s => {
            const dt = new Date(s.date + 'T00:00:00')
            return dt.getDate() + '/' + (dt.getMonth() + 1)
          }),
          labels: { style: { colors: '#adb5bd', fontSize: '11px' } },
          axisBorder: { show: false },
          axisTicks: { show: false }
        },
        yaxis: { labels: { style: { colors: '#adb5bd', fontSize: '11px' } } },
        tooltip: { shared: true }
      }
    }
  },
  mounted () { this.reload() },
  methods: {
    reload () {
      services.metricsSummary().then(r => { this.summary = r.data.data }).catch(() => errorMessage('Falha ao carregar métricas.', 3000))
      services.metricsDashboard().then(r => {
        const d = r.data.data
        this.series = d.series || []
        this.topRanking = d.top_ranking || []
        this.latestOrders = d.latest_orders || []
        this.chartReady = true
      }).catch(() => { this.chartReady = false })
    }
  }
}
</script>
